/**
 * Enables tracing of routing, meaning it will print in the console each route change success or error
 */
export const ROUTE_TRACING = false;

/**
 * Enables the collection of tracing stats in the browser. The stats are exposed as array in `window.gtmhubTracingStats.items`.
 * You can aggregate them by calling `window.gtmhubTracingStats.aggregate()` - you will get an object where stats are grouped
 * by session, screen and action. To enable these stats, just put any string as a value of the variable.
 */
export const INBROWSER_TRACING_STATS = false;
